import { lazy, useEffect } from "react";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from "./components/CoreComponents/Modal";
import LayersProvider from "./components/Providers/LayersProvider";
import MsalLayerProvider from "./components/Providers/MsalLayerProvider";
import ProvidersTreeBuilder from "./components/Providers/ProvidersTreeBuilder";
import QueryProvider from "./components/Providers/QueryProvider";
import ReduxProvider from "./components/Providers/ReduxProvider";
import SWChannelProvider from "./components/Providers/SWChannelProvider";
import { routes } from "./Constants/Routes";
import RouterLayout from "./Layouts/RouterLayout";
import NoPage from "./Pages/NoPage";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary.tsx";

// import { registerSW } from 'virtual:pwa-register'

// Leaving commented out code for loading implementation later

// import { useState, useEffect } from 'react';
// import InitialLoader from './components/InitialLoader/InitialLoader';

const Projects = lazy(() => import('./Pages/Projects/Projects.tsx'));
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={
      <RouterLayout />
    }>
      {Object.keys(routes).map((routeName, i) => {
        const route = routes[routeName];
        if (route.LazyLoaded) {
          return (
            <Route
              key={`${route.Props.path}${i}`}
              {...route.Props}
              element={
                <ErrorBoundary allowHardReload
                  reportError={(error, info) => {
                    console.error("Routes Wrapper Reported error", { error, info });
                  }}>
                  <Projects />
                </ErrorBoundary>
              }
            />
          )
        }
        return (
          <Route
            key={`${route.Props.path}${i}`}
            {...route.Props}
            element={
              <ErrorBoundary allowHardReload
                reportError={(error, info) => {
                  console.error("Routes Wrapper Reported error", { error, info });
                }}>
                <route.Component />
              </ErrorBoundary>
            }
          />
        );
      })}
      <Route
        path="*"

        Component={() => (
          <NoPage />
        )}
      />
    </Route>
  ),
  {
    future: {
      v7_startTransition: true,
    },
  }
);


function App() {
  const ProvidersTree = ProvidersTreeBuilder([ReduxProvider, QueryProvider, SWChannelProvider, LayersProvider, MsalLayerProvider]);
  //  Need to calculate the loading from the downloaded user data to make this an actual loader
  // Hiding it for now

  useEffect(() => {
    // registerSW({ immediate: true })
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (const registration of registrations) {
        registration.update();
        if (registration.waiting) {
          // console.log("is waitnig from mt");
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      }
    });


    // fetchApi(URL.postUserLogUrl()).then(res => res.json()).then(d => {
    //   // console.log("QA: ", d);
    // })

  }, [])


  return (
    <ErrorBoundary
      allowHardReload
      reportError={(error, info) => {
        console.error("App ErrorBoundary Reported error", { error, info });
      }}
    >
      <ProvidersTree>
        <RouterProvider router={router} />
        <Modal />
        <ToastContainer
          pauseOnHover
          theme="light"
        />
      </ProvidersTree>
    </ErrorBoundary>
  );
}

export default App;
